import { DataCard } from '@/reports/index';
import {
  build as buildDataCardBadge,
  DataCardBadgeTruthinessMapping,
} from '@/reports/shared/DataCard/DataCardBadge/DataCardBadge';
import {
  build as buildTag,
  DataCardTagTruthinessMapping,
} from '@/reports/shared/DataCard/DataCardTag/DataCardTag';
import { peopleTypes } from '@/reports/types';
import { DataList } from '@/theme/components';
import { getDatesAttended } from '@/utils/index';
import { isNewInfoItem } from '@/utils/isNewInfoItem/isNewInfoItem';

interface EducationCardProps {
  education: peopleTypes.Educations[number];
  thumbRating: () => JSX.Element;
}

export const EducationCard: React.FC<EducationCardProps> = ({
  education,
  thumbRating,
}) => {
  const tableStyles = {
    wordBreak: 'break-all',
  };

  const datesAttended = getDatesAttended(education);
  const degrees =
    education.known_degrees?.map((degree: string) => ['Degree', degree]) || [];

  const badge = () => {
    const badgeMapping: DataCardBadgeTruthinessMapping[] = [
      {
        name: 'bestMatch',
        truthiness: education?.meta?.is_best || false,
        insert: 'phone number',
      },
    ];

    return buildDataCardBadge(badgeMapping);
  };

  const tag = () => {
    const tagMapping: DataCardTagTruthinessMapping[] = [
      {
        name: 'newInfo',
        truthiness: isNewInfoItem({
          newInfo: education?.new_info,
          monitoredChangeType: education?.meta?.monitored_change_type,
          monitoredOn: education?.meta?.monitored_on,
        }),
      },
    ];

    return buildTag(tagMapping);
  };

  return (
    <DataCard
      tag={tag()}
      badge={badge()}
      thumbRating={thumbRating}
      titleProps={{ title: education.school || '' }}
      cardStyles={{ mb: 0 }}
    >
      <DataList
        tableStyles={tableStyles}
        items={[...degrees, ['Dates attended', datesAttended]]}
      />
    </DataCard>
  );
};
